import { Game } from "../Game";
import { Stadium } from "./Stadium/Stadium";



export class View {
    get globalLight(): pc.Entity { return this._globalLight; }
    private _globalLight: pc.Entity;

    get goalLight(): pc.Entity { return this._goalLight; }
    private _goalLight: pc.Entity;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        // Dynamicke svetlo
        let app = Game.app;
        let light = this._globalLight = new pc.Entity("light");

        light.addComponent(pc.eCompomentType.light, {
            type: pc.LIGHTTYPE_DIRECTIONAL,
            color: new pc.Color().fromString("#FFFFFF"),
            intensity: 1,
            isStatic: true,

            bake: false,
            affectDynamic: true,
            affectLightmapped: false,

            castShadows: true,
            shadowResolution: (pc.platform.ios || pc.platform.windows || pc.platform.desktop ? 2048 : 1024),
            shadowDistance: 32,
            shadowBias: 0.2,
            normalOffsetBias: 0.05,
            shadowType: pc.SHADOW_PCF5,
        });
        light.setEulerAngles(45, 15, 0);
        app.root.addChild(light);

        let layerList = [...light.light.layers];

        layerList.push(Game.manualSortLayer.id);
        light.light.layers = layerList;

        // Spot light u brany
        light = this._goalLight = new pc.Entity();
        light.addComponent(pc.eCompomentType.light, {
            type: "omni",
            //shape: pc.LIGHTSHAPE_SPHERE,
            color: new pc.Color(0.9, 1, 0.9),
            intensity: 5,
            //isStatic: true,
            affectDynamic: true,
            affectLightmapped: false,
            castShadows: false,
            range: 10,
            falloffMode: pc.LIGHTFALLOFF_LINEAR,
            layers: layerList
        });
        light.setPosition(0, 6, Stadium.END_Z + 1);
        app.root.addChild(light);

        // Ambient svetlo
        app.scene.toneMapping = pc.TONEMAP_LINEAR;
        app.scene.exposure = 1.3;
        app.scene.gammaCorrection = pc.GAMMA_SRGB;
        app.scene.ambientLight.fromString("#505050");
    }
}